module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p>注：前往浏览器顶部右上角<span class="skin-icon"></span></p><p>进入皮肤中心，可恢复成默认皮肤</p><div class="btn"><a class="downQb close">我知道了</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/skin.html
// module id = 34
// module chunks = 0